/** Pixen Intrigue — English overrides for the Books & Rules feature. Courtly-fae voice. */
export const booksPixEn = {
  // BackerVerifyPage.tsx
  'books.backerVerify.seoDescription': 'Verifying your Pixen Intrigue backer sign-in link.',
  'books.backerVerify.browseAthenaeum': 'Browse the Archive',

  // BookStorePage.tsx
  'books.store.seoDescription':
    'The tomes that arm you for the Court — core rules, intrigue scenarios, and the secrets of the fae. Buy to unlock modules and earn favors.',
  'books.store.eyebrow': 'The Ledger',
  'books.store.intro':
    'Acquire the tomes that bind the Court together. Every purchase unlocks playable modules in your campaigns and pays out favors for the in-world economy.',
  'books.store.loading': 'Unsealing the Ledger…',
  'books.store.empty': 'No tomes match this category yet. The scribes are still gathering whispers.',

  // BuyButton.tsx
  'books.buy.signInToClaim': 'Sign in to claim this tome.',
  'books.buy.ledgerSealed': 'The Court ledger is sealed for now — checkout is coming soon.',
  'books.buy.openingVault': 'Opening the vault…',

  // BookDetailPage.tsx
  'books.detail.backToAthenaeum': 'Back to the Archive',
  'books.detail.unlockOwned': 'You own this tome — its Pixen Intrigue lore is unlocked across the encyclopedia.',
  'books.detail.unlockClaim': 'Claim this tome to unlock its Pixen Intrigue lore across the encyclopedia.',
  'books.detail.noDescription': 'No description has been recorded for this volume yet.',
  'books.detail.previewBlurb': 'Glimpse a sample of this tome before you claim it.',
  'books.detail.unlockedLockedNote':
    'Purchase this tome to record its rivals, favors, and secrets into your encyclopedia — and claim',

  // CampaignLandingPage.tsx
  'books.campaign.previewsEmpty': 'New canon is still being whispered — check back as goals unlock.',
  'books.campaign.pledgeFooter':
    'Pledges are processed securely at checkout. Backing rewards (favors, modules, and encyclopedia unlocks) are granted to your Pixen Intrigue account once the campaign service goes live.',

  // CampaignLandingPage.tsx — fallback campaign identity, shown only when no real campaign row exists yet
  'books.campaign.fallbackTitle': 'Pixen Intrigue',
  'books.campaign.fallbackTagline': 'A game of fae-court intrigue and social scheming where your legend becomes canon.',
  'books.campaign.fallbackPitch':
    'The Court convenes. Pixen Intrigue is a fully-realized tabletop world — a living encyclopedia of rivals, favors, and hidden courts that grows with every backer. Fund the campaign and your support literally writes the world: each stretch goal auto-populates the shared encyclopedia with new playable canon you can drop straight into your campaigns.',

  // PreviewModal.tsx
  'books.preview.cannotDisplay': 'Your device cannot display the preview inline.',
  'books.preview.preparingBody':
    'A sample of this tome is being prepared behind the veil and will appear here shortly. In the meantime, glimpse what lies within:',
  'books.preview.excerptFallback':
    'Beyond this threshold lie pages steeped in glamour and gossip. Acquire the tome to read on.',

  // RulesPage.tsx
  'books.rules.seoDescription':
    'Browse the System Reference Document — courts, favors, and the rules that govern the fae. Pixen Intrigue now, with more systems to come.',
  'books.rules.eyebrow': 'The Archive',
  'books.rules.intro':
    'The open game content that powers Pixen Intrigue. Browse rules-relevant entries and dive into the full encyclopedia for stat blocks and lore. Pixen Intrigue ships with SRD 5.2.1 today — its own bespoke system is on the way.',
  'books.rules.loading': 'Consulting the Archive…',
}
